// HorizontalBarChart.tsx
import React from 'react';
import ApexCharts from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import useResponsive from '../../hooks/useResponsive';
import { useTheme } from '@mui/material/styles';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

interface HorizontalBarOptionProps {
  name: string;
  data: number[];
  labels: string[];
}

// export const EmployeeHorizontalBarChart: React.FC<HorizontalBarOptionProps> = ({
//   name,
//   data,
//   labels,
// }) => {
//   const theme = useTheme();

//   const series = [
//     {
//       data: data,
//     },
//   ];

//   const options: ApexOptions = {
//     chart: {
//       type: "bar",
//       height: 200,
//       toolbar: {
//         show: false, // Disable the toolbar (menu)
//       },
//     },
//     plotOptions: {
//       bar: {
//         borderRadius: 2,
//         borderRadiusApplication: "end",
//         barHeight: "20%",
//         horizontal: true, // Makes the bar chart horizontal
//       },
//     },
//     dataLabels: {
//       enabled: false, // Disable data labels
//     },
//     title: {
//       text: name,
//       align: "left",
//     },
//     grid: {
//       yaxis: {
//         lines: {
//           show: false,
//         },
//       },
//     },
//     xaxis: {
//       categories: labels,
//       labels: {
//         formatter: (val) => `${Math.round(Number(val))}`, // removes decimals on x-axis
//       },
//     },

//     colors: [`${theme.palette.primary.main}`, `${theme.palette.primary.light}`], // Add this line to set the colors for the series
//   };

//   return (
//     <div>
//       <ApexCharts options={options} series={series} type="bar" height={230} />
//     </div>
//   );
// };

// BarChart.tsx

// export const EmployeeLineChart: React.FC<HorizontalBarOptionProps> = ({
//   name,
//   data,
//   labels,
// }) => {
//   const theme = useTheme();

//   const series = [
//     {
//       name: name,
//       data: data,
//     },
//   ];

//   const options: ApexOptions = {
//     chart: {
//       type: "line",
//       height: 230,
//       toolbar: { show: false },
//       zoom: { enabled: false },
//     },
//     stroke: {
//       curve: "smooth", // makes it look better
//       width: 3,
//       colors: ["#2F66F4"],
//     },
//     markers: {
//       size: 4,
//       colors: ["#2F66F4"],
//       strokeWidth: 2,
//       hover: { size: 6 },
//     },
//     grid: {
//       yaxis: {
//         lines: { show: true },
//       },
//       xaxis: {
//         lines: { show: false },
//       },
//       borderColor: "#E5E7EB",
//       strokeDashArray: 4,

//     },
//     dataLabels: {
//       enabled: false,
//     },
//     xaxis: {
//       categories: labels,
//       labels: {
//         rotate: -45,
//         style: {
//           colors: "#6B7280",
//         },
//       },
//     },
//     yaxis: {
//       labels: {
//         formatter: (val) => `${Math.round(Number(val))}`,
//       },
//     },
//     colors: ["#2F66F4"],
//   };

//   return (
//     <Card sx={{ backgroundColor: "#FFF", borderRadius: 2, boxShadow: 1 }}>
//       <CardContent>
//         <Typography
//           variant="h6"
//           sx={{ color: "#64748B", mb: 2, fontWeight: 600 }}
//         >
//           {name}
//         </Typography>

//         <ApexCharts
//           options={options}
//           series={series}
//           type="bar"
//           height={230}
//         />
//       </CardContent>
//     </Card>
//   );
// };

interface BarChartOptions {
  id: string[];
  labels: number[];
}

// export const EmploymentBarChart: React.FC<BarChartOptions> = ({
//   id,
//   labels,
// }) => {
//   const theme = useTheme();
//   const isMedium = useResponsive("down", "md", "xl");
//   const isSmall = useResponsive("down", "sm", "xl");
//   const series = [
//     {
//       name: "Sales",
//       data: labels,
//     },
//   ];

//   const options: ApexOptions = {
//     chart: {
//       type: "bar",
//       toolbar: {
//         show: false, // Disable the toolbar (menu)
//       },
//     },
//     tooltip: {
//       y: {
//         formatter: (val) => `${Math.round(val)}`, // removes decimals in tooltip
//       },
//     },
//     yaxis: {
//       labels: {
//         formatter: (val) => `${Math.round(val)}`, // removes decimals on y-axis
//       },
//     },

//     xaxis: {
//       categories: id,
//     },
//     title: {
//       text: "Active Employees Department",
//       align: "left",
//     },
//     plotOptions: {
//       bar: {
//         horizontal: false,
//         columnWidth: isSmall ? "15%" : isMedium ? "15%" : "15%",
//       },
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     stroke: {
//       show: true,
//       width: 2,
//       colors: ["transparent"],
//     },
//     grid: {
//       row: {
//         colors: ["#fff", "transparent"],
//         opacity: 0.5,
//       },
//       show: true,
//       borderColor: "#E7EAEE",
//       strokeDashArray: 4, // Make the grid lines dotted
//       position: "back",
//     },
//     colors: [`${theme.palette.primary.main}`, `${theme.palette.primary.light}`], // Add this line to set the colors for the series
//   };

//   return (
//     <ApexCharts options={options} series={series} type="bar" height={350} />
//   );
// };

// export const EmploymentBarChart: React.FC<BarChartOptions> = ({
//   id,
//   labels,
// }) => {
//   const theme = useTheme();
//   const isMedium = useResponsive("down", "md", "xl");
//   const isSmall = useResponsive("down", "sm", "xl");

//   const series = [
//     {
//       name: "Employees",
//       data: labels,
//     },
//   ];

//   const options: ApexOptions = {
//     chart: {
//       type: "bar",
//       toolbar: { show: false },
//     },
//     tooltip: {
//       y: {
//         formatter: (val) => `${Math.round(val)}`,
//       },
//     },
//     yaxis: {
//       labels: {
//         formatter: (val) => `${Math.round(val)}`,
//       },
//     },
//     xaxis: {
//       categories: id,
//     },
//     title: {
//       text: "",
//       align: "left",
//     },
//     plotOptions: {
//       bar: {
//         horizontal: false,
//         columnWidth: isSmall ? "35%" : isMedium ? "25%" : "20%",
//         borderRadius: 4,
//       },
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     stroke: {
//       show: true,
//       width: 1,
//       colors: ["transparent"],
//     },
//     grid: {
//       row: {
//         colors: ["#f9fafb", "transparent"],
//         opacity: 0.5,
//       },
//       show: true,
//       borderColor: "#E7EAEE",
//       strokeDashArray: 4,
//       position: "back",
//     },
//     colors: ["#2F66F4"], // primary color
//   };

//   return (
//     <Card sx={{ backgroundColor: "#F9FAFB", borderRadius: 2, boxShadow: 1 }}>
//       <CardContent>
//         <Typography
//           variant="h6"
//           sx={{ color: "#2F66F4", mb: 2, fontWeight: 600 }}
//         >
//           Active Employees by Department
//         </Typography>

//         <ApexCharts options={options} series={series} type="bar" height={350} />
//       </CardContent>
//     </Card>
//   );
// };

interface HorizontalBarOptionProps {
  name: string;
  data: number[];
  labels: string[];
}

export const EmployeePieChart: React.FC<HorizontalBarOptionProps> = ({
  name,
  data,
  labels,
}) => {
  const theme = useTheme();

  const options: ApexOptions = {
    chart: {
      type: 'pie',
      toolbar: { show: false },
      animations: {
        enabled: true,
      },
    },
    labels: labels,
    colors: [
      '#2F66F4', // Primary blue
      theme.palette.secondary.main,
      theme.palette.error.main,
      theme.palette.warning.main,
      theme.palette.info.main,
      theme.palette.success.main,
      '#9C27B0', // Purple
      '#FF9800', // Orange
      '#795548', // Brown
      '#607D8B', // Blue Grey
      '#E91E63', // Pink
      '#00BCD4', // Cyan
    ],
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return val.toFixed(1) + '%';
      },
      style: {
        colors: ['#fff'],
        fontSize: '12px',
        fontWeight: '600',
      },
    },
    legend: {
      position: 'bottom',
      labels: {
        colors: theme.palette.text.secondary,
        useSeriesColors: false,
      },
      markers: {
        shape: 'square',
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },
    tooltip: {
      theme: theme.palette.mode,
      y: {
        formatter: function (val: number) {
          return `${Math.round(val)} items`;
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '0%', // Set to 0% for full pie, increase for donut effect
        },
        expandOnClick: true,
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['#fff'],
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 280,
          },
          legend: {
            position: 'bottom',
            fontSize: '12px',
          },
          dataLabels: {
            style: {
              fontSize: '10px',
            },
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            width: 320,
          },
        },
      },
    ],
    noData: {
      text: 'No data available',
      align: 'center',
      verticalAlign: 'middle',
      style: {
        color: theme.palette.text.secondary,
        fontSize: '14px',
      },
    },
  };

  // Handle empty data
  const chartData = data && data.length > 0 ? data : [1];
  const chartLabels = labels && labels.length > 0 ? labels : ['No Data'];

  return (
    <Card
      sx={{
        backgroundColor: '#FFF',
        borderRadius: 2,
        boxShadow: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          '&:last-child': { pb: 2 },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: '#64748B',
            mb: 2,
            fontWeight: 600,
            minHeight: '32px',
            textAlign: 'center',
          }}
        >
          {name}
        </Typography>

        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ApexCharts
            options={{
              ...options,
              labels: chartLabels,
            }}
            series={chartData}
            type="pie"
            height={330}
            width="100%"
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export const EmploymentBarChart: React.FC<BarChartOptions> = ({
  id,
  labels,
}) => {
  const theme = useTheme();
  const isMedium = useResponsive('down', 'md', 'xl');
  const isSmall = useResponsive('down', 'sm', 'xl');

  const series = [
    {
      name: 'Employees',
      data: labels,
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 350, // Consistent height
      toolbar: { show: false },
    },
    tooltip: {
      y: {
        formatter: (val) => `${Math.round(val)}`,
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${Math.round(val)}`,
      },
    },
    xaxis: {
      categories: id,
    },
    title: {
      text: '',
      align: 'left',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: isSmall ? '35%' : isMedium ? '25%' : '20%',
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['transparent'],
    },
    grid: {
      row: {
        colors: ['#f9fafb', 'transparent'],
        opacity: 0.5,
      },
      show: true,
      borderColor: '#E7EAEE',
      strokeDashArray: 4,
      position: 'back',
    },
    colors: ['#2F66F4'],
  };

  return (
    <Card
      sx={{
        backgroundColor: '#FFF',
        borderRadius: 2,
        boxShadow: 1,
        height: '100%', // Ensures card takes full height of container
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          '&:last-child': { pb: 2 }, // Consistent padding
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: '#64748B',
            mb: 2,
            fontWeight: 600,
            minHeight: '32px', // Consistent title height
          }}
        >
          Active Employees by Department
        </Typography>

        <Box sx={{ flexGrow: 1 }}>
          <ApexCharts
            options={options}
            series={series}
            type="bar"
            height={350} // Consistent height
          />
        </Box>
      </CardContent>
    </Card>
  );
};


// Usage example - wrap both charts in a Grid for proper alignment
const ChartContainer: React.FC = () => {
  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid item xs={12} md={6}>
        {/* <EmployeeLineChart 
          name="Employee Performance" 
          data={[10, 20, 30, 40]} 
          labels={["Q1", "Q2", "Q3", "Q4"]} 
        /> */}
      </Grid>
      <Grid item xs={12} md={6}>
        <EmploymentBarChart
          id={['HR', 'IT', 'Sales', 'Marketing']}
          labels={[15, 25, 35, 20]}
        />
      </Grid>
    </Grid>
  );
};
